import { render } from "./AddGroupSettings.vue?vue&type=template&id=818a003e&scoped=true&ts=true"
import script from "./AddGroupSettings.vue?vue&type=script&lang=ts"
export * from "./AddGroupSettings.vue?vue&type=script&lang=ts"

import "./AddGroupSettings.vue?vue&type=style&index=0&id=818a003e&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818a003e"]])

export default __exports__